export const blacklistEntries = [
  {
    id: "lexiang-mall",
    name: "乐享商城",
    domain: "lexiang-mall.example",
    category: "电商购物",
    categoryKey: "ecommerce",
    riskLevel: "high",
    riskText: "高危 · 疑似跑路",
    summary:
      "大量用户反馈下单后长期不发货，客服逐步失联，平台 App 于 2026 年 5 月起无法正常登录，疑似经营方已停止运营。",
    reportedAt: "2026-03-12",
    updatedAt: "2026-08-30",
    views: 26418,
    complaintCount: 342,
    amountLevel: "单笔损失多为 300–3000 元",
    tags: ["长期不发货", "客服失联", "退款无门", "App 停服"],
    signals: [
      { title: "低价引流", desc: "商品价格普遍低于市场价 40% 以上，用超低价吸引下单并催促尽快付款。" },
      { title: "发货异常", desc: "付款后物流信息长期不更新，部分订单显示已发货但查无此单号。" },
      { title: "客服话术推诿", desc: "统一回复“仓库爆仓、系统升级”，随后逐步停止回复消息。" },
      { title: "提现受限", desc: "平台余额提现需达到高额门槛，达标后又以风控审核为由拒绝。" }
    ],
    timeline: [
      { date: "2026-03", title: "投诉量明显上升", desc: "3 月起集中出现发货延迟与退款拖延的反馈。" },
      { date: "2026-05", title: "App 无法登录", desc: "用户反馈客户端提示服务不可用，网页端访问异常。" },
      { date: "2026-06", title: "客服渠道关闭", desc: "在线客服与售后电话均无法接通，社群被解散。" },
      { date: "2026-08", title: "持续停摆", desc: "截至更新时仍未恢复运营，退款申请无人受理。" }
    ],
    complaintStats: [
      { label: "发货问题", value: 46 },
      { label: "退款纠纷", value: 31 },
      { label: "客服失联", value: 15 },
      { label: "其他", value: 8 }
    ],
    howToSpot: [
      "全站商品价格明显低于主流渠道，且以“限时秒杀”制造紧迫感",
      "下单前无法核实营业执照与真实售后地址",
      "支付方式只支持扫码转账或个人账户收款"
    ],
    advice: [
      "尽快整理订单号、支付凭证与聊天记录，截图保存并做好备份",
      "先通过支付渠道申请交易投诉或拒付，银行/支付平台有时间窗口",
      "同步在 12315 平台提交投诉，注明商家名称与统一社会信用代码（如有）"
    ],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20online%20shopping%20risk%20with%20floating%20parcel%20boxes%20and%20a%20fading%20shopping%20cart%2C%20muted%20amber%20and%20charcoal%20palette%2C%20geometric%20warning%20shapes%2C%20clean%20soft%20gradient%20background%2C%20no%20text%2C%20minimal%20flat%20design&width=900&height=600&seq=blk-cover-ecommerce-2026&orientation=landscape"
  },
  {
    id: "jinying-licai",
    name: "金盈理财",
    domain: "jinying-licai.example",
    category: "投资理财",
    categoryKey: "finance",
    riskLevel: "high",
    riskText: "高危 · 疑似资金盘",
    summary:
      "以“日化收益、保本高息”为卖点吸引用户充值，收益提现初期正常，后期以各种理由拖延，具备典型资金盘特征。",
    reportedAt: "2026-01-20",
    updatedAt: "2026-09-01",
    views: 41277,
    complaintCount: 518,
    amountLevel: "单笔损失多为 5000–50000 元",
    tags: ["高息诱惑", "提现拖延", "拉人头返利", "层级返佣"],
    signals: [
      { title: "承诺保本高息", desc: "年化收益远超正常理财水平，并宣称“稳赚不赔”。" },
      { title: "拉人返佣", desc: "发展下线可获得多级返利，收益与拉新强绑定。" },
      { title: "提现设障", desc: "初期小额可提，充值变大后需缴纳“解冻费、税费”。" },
      { title: "主体模糊", desc: "无法说明资金投向，也无法出示合规的金融资质。" }
    ],
    timeline: [
      { date: "2026-01", title: "投诉开始出现", desc: "用户反映提现审核时间被无故拉长。" },
      { date: "2026-03", title: "强制复投", desc: "平台以活动名义要求将本金继续锁定，否则冻结收益。" },
      { date: "2026-06", title: "要求缴解冻费", desc: "提现前需先转账缴纳费用，缴费后仍未到账。" },
      { date: "2026-09", title: "社群解散", desc: "多个官方群组被解散，客服停止响应。" }
    ],
    complaintStats: [
      { label: "提现失败", value: 52 },
      { label: "诱导复投", value: 22 },
      { label: "虚假宣传", value: 16 },
      { label: "其他", value: 10 }
    ],
    howToSpot: [
      "收益来源说不清，只强调“稳定高回报”",
      "鼓励不断加大投入，并设拉人奖励",
      "提现需要额外缴费或满足复杂条件"
    ],
    advice: [
      "立即停止追加任何款项，尤其是所谓的解冻费与税费",
      "保存转账记录、账户截图、推广话术，形成完整证据链",
      "就近向公安机关报案，并同步向金融监管部门反映"
    ],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20about%20investment%20ponzi%20scheme%20risk%2C%20declining%20chart%20line%20and%20stacked%20coin%20shapes%20fading%20out%2C%20dark%20amber%20and%20crimson%20accents%20on%20warm%20charcoal%2C%20geometric%20minimal%20flat%20design%2C%20soft%20gradient%20background%2C%20no%20text&width=900&height=600&seq=blk-cover-finance-2026&orientation=landscape"
  },
  {
    id: "youxin-jianzhi",
    name: "优信兼职",
    domain: "youxin-jianzhi.example",
    category: "网络兼职",
    categoryKey: "parttime",
    riskLevel: "high",
    riskText: "高危 · 刷单诈骗",
    summary:
      "以“点赞、刷单返现”为名招募兼职，前期小额返利建立信任，随后以大额任务为由要求垫付，最终无法提现。",
    reportedAt: "2026-02-08",
    updatedAt: "2026-08-22",
    views: 33891,
    complaintCount: 401,
    amountLevel: "单笔损失多为 1000–20000 元",
    tags: ["刷单返利", "垫付本金", "任务未结算", "拉群诱导"],
    signals: [
      { title: "先返小钱", desc: "前几单正常返现，用来降低用户戒心。" },
      { title: "任务金额跳涨", desc: "突然出现需要垫付的高额连单，称完成即返。" },
      { title: "提现需补单", desc: "以“操作错误、任务未完成”为由要求继续充值。" },
      { title: "私域联系", desc: "全程通过私聊与临时群组沟通，随时解散。" }
    ],
    timeline: [
      { date: "2026-02", title: "招兼职高峰", desc: "在多个平台投放“日结兼职”广告。" },
      { date: "2026-04", title: "大额垫付投诉", desc: "集中出现垫付后无法返现的反馈。" },
      { date: "2026-07", title: "群组解散", desc: "任务群被解散，对接人拉黑用户。" }
    ],
    complaintStats: [
      { label: "垫付不返", value: 58 },
      { label: "提现受阻", value: 24 },
      { label: "诱导充值", value: 12 },
      { label: "其他", value: 6 }
    ],
    howToSpot: [
      "任何要求先垫付资金的“兼职”都值得警惕",
      "收益与任务金额同步快速放大",
      "全程只通过私人聊天工具沟通"
    ],
    advice: [
      "保留完整聊天记录与转账截图，不要删除任何对话",
      "第一时间联系银行/支付平台申请止付，争取冻结资金",
      "携带证据到就近派出所报案，并保存报案回执"
    ],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20about%20online%20part%20time%20job%20scam%2C%20chat%20bubbles%20and%20a%20laptop%20silhouette%20with%20distorted%20geometric%20grid%2C%20muted%20teal%20charcoal%20and%20amber%20palette%2C%20minimal%20flat%20design%2C%20soft%20gradient%20background%2C%20no%20text&width=900&height=600&seq=blk-cover-parttime-2026&orientation=landscape"
  },
  {
    id: "xinghe-dai",
    name: "星河贷",
    domain: "xinghe-dai.example",
    category: "网络贷款",
    categoryKey: "loan",
    riskLevel: "high",
    riskText: "高危 · 疑似套路贷",
    summary:
      "以“低门槛、秒到账”吸引借款，实际存在砍头息、服务费不明、催收骚扰等问题，综合成本远超宣传。",
    reportedAt: "2025-12-15",
    updatedAt: "2026-08-18",
    views: 29540,
    complaintCount: 288,
    amountLevel: "涉及年化成本普遍超过宣传数倍",
    tags: ["砍头息", "费用不透明", "暴力催收", "过度索权"],
    signals: [
      { title: "宣传与实际不符", desc: "宣称低息，实际叠加各类服务费与管理费。" },
      { title: "强制读取通讯录", desc: "申请时要求开放通讯录、相册等无关权限。" },
      { title: "还款金额对不上", desc: "实际还款额高于合同明示金额。" },
      { title: "催收施压", desc: "逾期后高频联系本人及通讯录联系人。" }
    ],
    timeline: [
      { date: "2025-12", title: "投诉集中", desc: "大量反馈费用不透明与催收骚扰。" },
      { date: "2026-03", title: "权限争议", desc: "用户反映被过度索取个人信息。" },
      { date: "2026-08", title: "仍有反馈", desc: "相关投诉仍持续出现。" }
    ],
    complaintStats: [
      { label: "费用不透明", value: 41 },
      { label: "催收骚扰", value: 33 },
      { label: "隐私过度索取", value: 18 },
      { label: "其他", value: 8 }
    ],
    howToSpot: [
      "放款金额与合同金额不一致",
      "申请流程要求开放与借贷无关的权限",
      "综合成本无法清晰计算"
    ],
    advice: [
      "保存借款合同、还款计划与每一笔流水",
      "对超出法定上限的费用，保留异议记录并依法主张",
      "遭遇骚扰催收时保存通话录音与短信，向监管部门举报"
    ],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20about%20predatory%20online%20loan%20risk%2C%20a%20torn%20contract%20document%20and%20warning%20triangle%20shapes%2C%20warm%20charcoal%20with%20crimson%20accents%2C%20geometric%20minimal%20flat%20design%2C%20soft%20gradient%20background%2C%20no%20text&width=900&height=600&seq=blk-cover-loan-2026&orientation=landscape"
  },
  {
    id: "qidi-education",
    name: "启迪教育",
    domain: "qidi-edu.example",
    category: "教育培训",
    categoryKey: "education",
    riskLevel: "mid",
    riskText: "中危 · 退费困难",
    summary:
      "课程销售时承诺“不过退款”，实际申请退费时门槛层层加码，退费周期长，部分用户反映被反复推诿。",
    reportedAt: "2026-04-02",
    updatedAt: "2026-08-26",
    views: 15420,
    complaintCount: 176,
    amountLevel: "单笔损失多为 3000–20000 元",
    tags: ["退费拖延", "口头承诺", "合同模糊", "销售话术"],
    signals: [
      { title: "口头承诺不入合同", desc: "退款条件只在销售话术中提及，合同未写明。" },
      { title: "退费条件复杂", desc: "设置课时完成度、材料费等隐性扣减项。" },
      { title: "流程反复", desc: "退费需多轮审批，期间不断被劝说转课。" }
    ],
    timeline: [
      { date: "2026-04", title: "退费投诉上升", desc: "集中出现退费申请长时间无进展的反馈。" },
      { date: "2026-06", title: "转课劝说", desc: "用户被建议将课程转为其他班型继续消费。" },
      { date: "2026-08", title: "部分处理", desc: "少量用户完成退费，但周期普遍偏长。" }
    ],
    complaintStats: [
      { label: "退费拖延", value: 49 },
      { label: "扣费争议", value: 27 },
      { label: "宣传不符", value: 16 },
      { label: "其他", value: 8 }
    ],
    howToSpot: [
      "重要承诺只存在于销售口头表达",
      "合同中的退款条款表述模糊",
      "付款指向个人账户而非公司账户"
    ],
    advice: [
      "把所有承诺要求写进合同补充条款并双方签字",
      "付款务必使用对公账户并保留发票",
      "退费被拖延时同步向 12315 与教育主管部门反映"
    ],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20about%20training%20course%20refund%20dispute%2C%20stacked%20books%20and%20a%20receipt%20paper%20with%20folded%20geometric%20corners%2C%20muted%20teal%20and%20amber%20palette%2C%20minimal%20flat%20design%2C%20soft%20gradient%20background%2C%20no%20text&width=900&height=600&seq=blk-cover-education-2026&orientation=landscape"
  },
  {
    id: "yueheng-shenghuo",
    name: "悦享生活卡",
    domain: "yueheng-card.example",
    category: "生活服务",
    categoryKey: "service",
    riskLevel: "mid",
    riskText: "中危 · 预付卡风险",
    summary:
      "以高折扣吸引用户大额充值预付卡，门店数量缩减后部分服务无法使用，且明确不支持退款。",
    reportedAt: "2026-05-11",
    updatedAt: "2026-08-12",
    views: 11238,
    complaintCount: 132,
    amountLevel: "单笔损失多为 500–8000 元",
    tags: ["预付充值", "门店缩减", "不支持退", "使用受限"],
    signals: [
      { title: "折扣诱导大额充值", desc: "充值越多折扣越大，鼓励一次性投入。" },
      { title: "门店减少", desc: "可用门店持续缩减，跨店使用受限。" },
      { title: "条款限制", desc: "充值后明确不可退，转让需额外手续费。" }
    ],
    timeline: [
      { date: "2026-05", title: "门店异常", desc: "用户反映部分门店停止接受预付卡。" },
      { date: "2026-07", title: "余额争议", desc: "集中出现余额无法正常消费的反馈。" }
    ],
    complaintStats: [
      { label: "余额受限", value: 44 },
      { label: "退款被拒", value: 30 },
      { label: "门店减少", value: 18 },
      { label: "其他", value: 8 }
    ],
    howToSpot: [
      "鼓励一次性投入大额资金换取高折扣",
      "充值条款写明不可退款或限制转让",
      "门店或服务点数量持续减少"
    ],
    advice: [
      "尽量小额多次充值，避免一次性大额投入",
      "保留充值凭证、卡号与消费记录",
      "服务无法使用时，向商务与市场监管部门投诉"
    ],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20about%20prepaid%20membership%20card%20risk%2C%20layered%20rounded%20card%20shapes%20and%20a%20closed%20storefront%20symbol%2C%20muted%20amber%20and%20deep%20teal%20palette%2C%20minimal%20flat%20design%2C%20soft%20gradient%20background%2C%20no%20text&width=900&height=600&seq=blk-cover-service-2026&orientation=landscape"
  },
  {
    id: "yunding-game",
    name: "云顶游戏盒子",
    domain: "yunding-game.example",
    category: "游戏娱乐",
    categoryKey: "gaming",
    riskLevel: "mid",
    riskText: "中危 · 充值异常",
    summary:
      "用户充值后虚拟道具长期未到账，客服以“订单异常需补单”为由要求再次充值，退款渠道不明确。",
    reportedAt: "2026-06-19",
    updatedAt: "2026-08-05",
    views: 9871,
    complaintCount: 94,
    amountLevel: "单笔损失多为 100–3000 元",
    tags: ["道具未到账", "补单话术", "退款难", "渠道分散"],
    signals: [
      { title: "充值未到账", desc: "支付成功但游戏内道具未发放。" },
      { title: "要求二次充值", desc: "客服称订单异常，需再充值才能激活。" },
      { title: "退款无入口", desc: "平台内没有公开的退款申请通道。" }
    ],
    timeline: [
      { date: "2026-06", title: "到账问题", desc: "集中出现充值后道具未发放的反馈。" },
      { date: "2026-08", title: "仍在处理", desc: "部分订单仍未解决，退款渠道不清。" }
    ],
    complaintStats: [
      { label: "道具未到账", value: 51 },
      { label: "诱导再充", value: 26 },
      { label: "退款难", value: 15 },
      { label: "其他", value: 8 }
    ],
    howToSpot: [
      "充值入口指向个人收款码或第三方代充",
      "出问题后要求再次充值才能解决",
      "没有公开可查的退款与售后规则"
    ],
    advice: [
      "优先通过支付渠道发起交易争议与退款申请",
      "保存充值订单号、支付截图与客服对话",
      "避免通过非官方代充渠道进行交易"
    ],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20about%20virtual%20game%20top%20up%20problem%2C%20game%20controller%20outline%20and%20floating%20coin%20shapes%20with%20glitch%20lines%2C%20muted%20crimson%20and%20charcoal%20palette%2C%20minimal%20flat%20design%2C%20soft%20gradient%20background%2C%20no%20text&width=900&height=600&seq=blk-cover-gaming-2026&orientation=landscape"
  },
  {
    id: "sugou-youxuan",
    name: "速购优选",
    domain: "sugou-youxuan.example",
    category: "电商购物",
    categoryKey: "ecommerce",
    riskLevel: "watch",
    riskText: "观察 · 投诉待核实",
    summary:
      "近期出现少量关于发货延迟与售后响应慢的反馈，目前投诉量有限且部分已协商解决，暂列入观察名单。",
    reportedAt: "2026-08-01",
    updatedAt: "2026-09-02",
    views: 5210,
    complaintCount: 23,
    amountLevel: "涉及金额相对较小",
    tags: ["发货延迟", "售后慢", "待观察", "部分已解决"],
    signals: [
      { title: "发货周期偏长", desc: "部分订单发货时间超过页面承诺时效。" },
      { title: "售后响应慢", desc: "工单排队时间较长，回复不及时。" }
    ],
    timeline: [
      { date: "2026-08", title: "少量反馈", desc: "出现少量发货与售后相关的反馈。" },
      { date: "2026-09", title: "部分解决", desc: "部分投诉在协商后得到处理。" }
    ],
    complaintStats: [
      { label: "发货延迟", value: 54 },
      { label: "售后慢", value: 32 },
      { label: "其他", value: 14 }
    ],
    howToSpot: [
      "下单前确认页面标注的发货时效",
      "留意近期是否集中出现同类问题",
      "保留订单与沟通记录以便追溯"
    ],
    advice: [
      "先通过平台官方售后渠道沟通并保留记录",
      "确认投诉是否具有普遍性再判断风险",
      "对观察名单中的平台谨慎进行大额交易"
    ],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20about%20observing%20an%20online%20shop%2C%20a%20large%20magnifier%20lens%20over%20minimal%20parcel%20and%20dashboard%20shapes%2C%20muted%20teal%20and%20soft%20amber%20palette%2C%20minimal%20flat%20design%2C%20soft%20gradient%20background%2C%20no%20text&width=900&height=600&seq=blk-cover-watch-2026&orientation=landscape"
  },
  {
    id: "haixiang-haitao",
    name: "海象海淘",
    domain: "haixiang-haitao.example",
    category: "电商购物",
    categoryKey: "ecommerce",
    riskLevel: "mid",
    riskText: "中危 · 物流与退款异常",
    summary:
      "跨境订单物流信息长期停滞，退换货需自行承担高额运费，部分用户反映退款到账金额与订单不符。",
    reportedAt: "2026-05-27",
    updatedAt: "2026-08-14",
    views: 12045,
    complaintCount: 143,
    amountLevel: "单笔损失多为 400–6000 元",
    tags: ["物流停滞", "退货运费高", "退款差额", "跨境售后"],
    signals: [
      { title: "物流长期不动", desc: "清关或运输状态长时间不更新。" },
      { title: "退货成本高", desc: "退换货需用户自付高额国际运费。" },
      { title: "退款金额不符", desc: "到账金额低于订单实际支付金额。" }
    ],
    timeline: [
      { date: "2026-05", title: "物流投诉", desc: "集中出现包裹长期停滞的反馈。" },
      { date: "2026-07", title: "退款差额", desc: "用户反映退款金额与支付金额不一致。" }
    ],
    complaintStats: [
      { label: "物流停滞", value: 45 },
      { label: "退款差额", value: 28 },
      { label: "运费争议", value: 19 },
      { label: "其他", value: 8 }
    ],
    howToSpot: [
      "下单前确认退换货成本由谁承担",
      "留意清关与物流时效承诺是否可查",
      "核对退款规则中的计算方式"
    ],
    advice: [
      "保留订单、支付与物流全流程截图",
      "退款金额有差异时先与平台书面确认",
      "协商不成可向平台所在地监管部门投诉"
    ],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20about%20cross%20border%20shopping%20logistics%20delay%2C%20a%20globe%20grid%20and%20a%20stalled%20conveyor%20of%20parcels%2C%20muted%20amber%20and%20deep%20teal%20palette%2C%20minimal%20flat%20design%2C%20soft%20gradient%20background%2C%20no%20text&width=900&height=600&seq=blk-cover-haitao-2026&orientation=landscape"
  }
];

export const riskCategories = [
  { key: "all", name: "全部类型", desc: "查看全部风险记录", icon: "ri-stack-line" },
  { key: "ecommerce", name: "电商购物", desc: "发货、退款、跑路类风险", icon: "ri-shopping-bag-3-line" },
  { key: "finance", name: "投资理财", desc: "高息与资金盘类风险", icon: "ri-line-chart-line" },
  { key: "parttime", name: "网络兼职", desc: "刷单与垫付类骗局", icon: "ri-briefcase-4-line" },
  { key: "loan", name: "网络贷款", desc: "收费不透明与催收问题", icon: "ri-hand-coin-line" },
  { key: "education", name: "教育培训", desc: "预付课程与退费纠纷", icon: "ri-book-open-line" },
  { key: "service", name: "生活服务", desc: "预付卡与门店风险", icon: "ri-store-3-line" },
  { key: "gaming", name: "游戏娱乐", desc: "虚拟充值与道具风险", icon: "ri-gamepad-line" }
];

export const siteStats = [
  { value: "12,860+", label: "累计收录风险线索" },
  { value: "3,240+", label: "已核实风险记录" },
  { value: "186,000+", label: "查询次数" },
  { value: "24h", label: "线索平均处理时长" }
];